<div class="card">
    <div class="card-title">
        <div class="title">
            <img *ngIf="icon" class="title-icon" [src]="icon" [alt]="title">
            <h3 placement="top" [ngbTooltip]="title" tooltipClass="ng-tooltip" class="text-truncate" [autoClose]="true"
                triggers="manual" #t="ngbTooltip" (click)="t.open()">{{title}}</h3>
        </div>
        <button type="button" class="btn-favorite" (click)="setFavorite()">
            <fa-icon class="star-icon" [icon]="setIcon()"></fa-icon>
        </button>
    </div>
    <div class="card-content">
        <ng-content></ng-content>
    </div>
</div>